/* unplugin-vue-components disabled */import script from "./SameBoard.vue?vue&type=script&setup=true&lang=js"
export * from "./SameBoard.vue?vue&type=script&setup=true&lang=js"

import "./SameBoard.vue?vue&type=style&index=0&id=319b92b9&scoped=true&lang=css"

import exportComponent from "/opt/buildhome/repo/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-319b92b9"]])

export default __exports__